import createBrowserHistory from 'history/createBrowserHistory';

const history = createBrowserHistory();
const location = history.location;

export {
	history,
	location
};

export default history;


// WEBPACK FOOTER //
// ./routes/configureHistory.js